export const PROJECT_SETTINGS_MODERNIZATION = 'project-settings-modernization';
